// Allowed paths for /Site Content/ in Pimcore
const SITE_CONTENT_PATHS = [
    '/_common',
    '/HomePage',
    '/Footer',
    '/Products',
    '/Applications',
    '/About/Careers',
    '/About/InvestorRelations',
    '/About/Newsroom',
    '/About/Sustainability',
    '/About/YageoGroupOverview',
    '/SalesAndResources/ContactPoints',
    '/SalesAndResources/ResourceLibrary',
    '/SalesAndResources/SensorAcademy',
    '/SalesAndResources/SimulationTools',
    '/SalesAndResources/DistributorPortals',
] as const;

type SiteContentPath = (typeof SITE_CONTENT_PATHS)[number];

export { SITE_CONTENT_PATHS };
export type { SiteContentPath };
